import { AxiosInstance } from 'axios';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { JobClassification } from '@trukt/types/Job';
import { PaginatedResults } from '@trukt/types/PaginatedResults';

export interface JobClassificationSearchRequest extends PaginatedQueryParams {
  orderId?: string;
  permitted?: boolean | null;
}

export type JobClassificationSearchItem = JobClassification;

export type JobClassificationSearchResponse = PaginatedResults<JobClassificationSearchItem>;

export class JobClassificationService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request: JobClassificationSearchRequest) {
    return this.instance.get<JobClassificationSearchResponse>('/jobs/classifications', {
      params: request,
    });
  }
}
